/**
 * Constantes para los nombres de los microservicios del sistema
 * Sistema de Salud Continua (SAL-SC) y Salud en el Trabajo (SAL-ST)
 */

// Microservicios del sistema de salud continua (SAL-SC)
export const ms1doc3 = '/SAL-SC-IntegracionPlanes/hbc/1doc3'
export const msaccount = '/SAL-SC-Usuarios/hbc/account'
export const msaudit = '/SAL-SC-Auditoria/hbc/audit'
export const msclinichistory = '/SAL-SC-HistoriaClinica/hbc/clinichistory'
export const mscommons = '/SAL-SC-Comun/hbc/commons'
export const mshl7 = '/SAL-SC-EstandarHl7/hbc/hl7'
export const msnotification = '/SAL-SC-Notificaciones/hbc/notification'
export const msprogram = '/SAL-SC-Programas/hbc/program'
export const msprovider = '/SAL-SC-Proveedores/hbc/provider'
export const msreports = '/SAL-SC-Reportes/hbc/reports'
export const msschedule = '/SAL-SC-Agendamiento/hbc/schedule'
export const mssmartfit = '/SAL-SC-RemisionesGimnasios/hbc/smartfit'
export const mssuscription = '/SAL-SC-Suscripciones/hbc/suscription'
export const mstreatment = '/SAL-SC-Tratamiento/hbc/treatment'

// Microservicio de salud en el trabajo (SAL-ST)
export const mshaw = '/SAL-ST-SaludEnElTrabajo/haw'
